module.exports = __webpack_public_path__ + "static/img/course-calendar.2601bcb2.png";